import { toApiErrorPayload } from '../../flux/facades/apiFacade';

export function detectionLabel(rule) {
    const labels = [];
    if (rule.definition.topologies.includes('Touching')) {
        const tolerance = rule.definition.overlapToleranceCm3;
        labels.push(tolerance === null ? 'Touching' : `Touching (tolerance ${tolerance} cm³)`);
    }
    if (rule.definition.minClearanceCm !== null) {
        labels.push(`Clearance ≥ ${rule.definition.minClearanceCm} cm`);
    }
    return labels.join(' + ') || 'Not configured';
}

export function apiErrorDetails(error) {
    return toApiErrorPayload(error);
}

export function errorMessage(error, operation) {
    const details = apiErrorDetails(error);
    if (details.status === 401) return 'Your session has expired. Sign in again to continue.';
    if (details.status === 403) return 'You do not have permission or the required license for this action.';
    if (details.status === 404 && (operation === 'load' || operation === 'create')) {
        return 'The Rules API endpoint is unavailable. Confirm that the backend rules feature is running.';
    }
    if (details.status === 404) return 'This rule no longer exists. The list has been refreshed.';
    if (details.status === 409 && operation === 'delete') return 'This rule is still active. Deactivate it before deleting.';
    if (details.status === 422) return details.message || 'The rule data is invalid.';
    if (details.status === 500) return 'The server could not complete the request. Please try again.';
    return `Unable to ${operation} the rule. Please try again.`;
}
